import * as React from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import {useEffect, useState} from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import VideoDetailsCard from "../videoDetails";

import Button from "@mui/material/Button";
import authService from '../api-authorization/AuthorizeService'
import SimpleBackdrop from "../backdrop";
import Box from "@mui/material/Box";
import Title from "../Title";
import IssueList from "../issues/issuelist";
import MDEditor, {commands} from "@uiw/react-md-editor";
import {useEditor} from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import moment from "moment/moment";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {Chip, FormControl, InputLabel, MenuItem, Pagination, Select, Snackbar, TableContainer, TextField, Tooltip} from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SmartDisplayIcon from "@mui/icons-material/SmartDisplay";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import TelegramIcon from "@mui/icons-material/Telegram";
import PublicIcon from "@mui/icons-material/Public";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
//https://codesandbox.io/s/jzbml?file=/src/MyDialog.js:3636-3640
export default function ChannelDetails({updateTitle}) {

    const [ channel, setChannel] = React.useState({videos:[]});
    const { id } = useParams();
    const [loading, setLoading] = React.useState(true);
    const [videosLoading, setVideosLoading] = React.useState(false);
    const [active, setActive] = React.useState(false);
    const [ video, setVideo] = React.useState({});
    const [videosPageData, setVideosPageData] = React.useState({
        items: [],
        page: 0,
        page_size: 50,
        total: 0,
        total_pages: 0
    });
    const [videosPage, setVideosPage] = React.useState(1);
    const [statusFilter, setStatusFilter] = React.useState("all");

    const fetchData = async () => {
        setLoading(true);
        //const token = await authService.getAccessToken();
        const response = await fetch('/api/channels/details/' + id, {
            //headers: !token ? {} : {'X-Authorization': `Bearer ${token}`} }
        });
        authService.followIfLoginRedirect(response);
        const data = await response.json();
        setChannel(data);
        if(data.notes){
            setValue(data.notes.note_text);
        }
        updateTitle("Details: " + data.handle);
        setLoading(false);
    }
    useEffect(() => {
        // declare the async data fetching function
        updateTitle("Details")
        console.log('here2');
        console.log(channel);
        

        // call the function
        fetchData()
            // make sure to catch any error
            .catch(console.error);;

        setStatusFilter("all");
        setVideosPage(1);
        fetchVideos(1, "all").catch(console.error);
    }, [id])

    const [openDialog, setOpenDialog] = useState(false);
    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const updateDetails = (v) => {
        //debugger;
        setOpenDialog(true);
        console.log(v);
        setVideo(v);
    };

    const [videoQuery, setVideoQuery] = React.useState("");

    const fetchVideos = async (pageToLoad = 1, statusToLoad = statusFilter) => {
        setVideosLoading(true);
        const response = await fetch(`/api/channels/details/${id}/videos?items=50&page=${Math.max(0, pageToLoad - 1)}&status=${encodeURIComponent(statusToLoad)}`);
        authService.followIfLoginRedirect(response);
        const data = await response.json();
        setVideosPageData(data);
        setVideosLoading(false);
    };

    const openVideoUrl = (v) => {
        if (!channel || !channel.channel_type || !v || !v.video_id) {
            return null;
        }
        if (channel.channel_type === "YouTube") {
            return `https://youtube.com/watch?v=${v.video_id}`;
        }
        if (channel.channel_type === "Twitch") {
            return `https://www.twitch.tv/videos/${v.video_id}`;
        }
        return null;
    };

    const editor = useEditor({
        extensions: [StarterKit],
        content: "",
    });
    const [value, setValue] = React.useState("");

    const [noteLoading, setnoteLoading] = React.useState(false);
    const saveNotes = async () => {

        setnoteLoading(true);
        var req = {
            notes: value
        }
        //const token = await authService.getAccessToken();
        const response = await fetch('/api/channels/details/'+channel.id+'/notes', {
            method: "PUT",
            headers: {/*'X-Authorization': `Bearer ${token}`,*/ 'Content-Type': 'application/json' },
            body: JSON.stringify(req)
        });
        authService.followIfLoginRedirect(response);
        console.log(response);
        setSnackOpen(true);
        setnoteLoading(false);
    }
    const [snackOpen, setSnackOpen] = React.useState(false);

    const handleClick = () => {
        setSnackOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackOpen(false);
    };

    const action = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    const filteredVideos = (videosPageData.items || []).filter((v) => {
        const q = (videoQuery || "").toLowerCase().trim();
        if (!q) {
            return true;
        }
        const title = (v.video_title || "").toLowerCase();
        const description = (v.video_description || "").toLowerCase();
        return title.includes(q) || description.includes(q) || (v.video_id || "").toLowerCase().includes(q);
    });
    const displayedVideos = filteredVideos;

    const getStatusLabel = (status) => {
        if (typeof status === "string") return status;
        const statusMap = {
            0: "Pending",
            1: "Downloaded",
            2: "Analysing",
            3: "Complete",
            4: "Failure",
            5: "DownloadFailure",
            6: "DeletedFromSource",
            100: "UnsupportedMedia",
            101: "ToLong"
        };
        return statusMap[status] || String(status ?? "Unknown");
    };

    const getStatusColor = (statusLabel) => {
        if (statusLabel === "Complete") return "success";
        if (statusLabel === "Failure" || statusLabel === "DownloadFailure" || statusLabel === "UnsupportedMedia" || statusLabel === "ToLong") return "error";
        if (statusLabel === "DeletedFromSource") return "default";
        return "warning";
    };

    const getChannelTypeIcon = (channelType) => {
        const t = (channelType || "").toLowerCase();
        if (t.includes("youtube")) return <SmartDisplayIcon sx={{ fontSize: 44 }} color="error" />;
        if (t.includes("tiktok")) return <MusicNoteIcon sx={{ fontSize: 44 }} color="action" />;
        if (t.includes("twitch")) return <SportsEsportsIcon sx={{ fontSize: 44 }} color="action" />;
        if (t.includes("telegram")) return <TelegramIcon sx={{ fontSize: 44 }} color="primary" />;
        return <PublicIcon sx={{ fontSize: 44 }} color="disabled" />;
    };

    
    return (
        <div>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}>
                {getChannelTypeIcon(channel.channel_type)}
                <Box>
                    <Typography variant="h4" sx={{ fontWeight: 800, lineHeight: 1.05 }}>
                        {channel.handle || "(unknown channel)"}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "text.secondary" }}>
                        {channel.channel_type || "Unknown Platform"}
                    </Typography>
                </Box>
            </Box>
            <VideoDetailsCard
                open={openDialog}
                handleOpenDialog={handleOpenDialog}
                handleCloseDialog={handleCloseDialog}
                row={video}
                active={active}
                parentCallback={updateDetails}
                channelId={id}
            />

            <Box component="div" sx={{mt: 3, mb: 2}}>
                <Title>Overview</Title>
                <Grid container spacing={1.5}>
                    {[
                        {
                            label: "Total Discovered",
                            value: (channel.total_discovered_videos ?? 0).toLocaleString(),
                            helper: "Videos tracked in this channel"
                        },
                        {
                            label: "Pending",
                            value: (channel.pending_videos ?? 0).toLocaleString(),
                            helper: "Waiting for processing/review"
                        },
                        {
                            label: "Failed",
                            value: (channel.failed_videos ?? 0).toLocaleString(),
                            helper: "Processing/download failures"
                        },
                        {
                            label: "Analysed",
                            value: (channel.total_analysed_videos ?? 0).toLocaleString(),
                            helper: "Completed analysis"
                        }
                    ].map((item) => (
                        <Grid item xs={12} sm={6} md={4} lg={2} key={item.label}>
                            <Card variant="outlined" sx={{height: "100%", borderRadius: 2}}>
                                <CardContent sx={{p: 1.5, "&:last-child": {pb: 1.5}}}>
                                    <Typography sx={{fontSize: 12, color: "#666", mb: 0.5}}>
                                        {item.label}
                                    </Typography>
                                    <Typography sx={{fontSize: {xs: 26, md: 30}, fontWeight: 800, lineHeight: 1}}>
                                        {item.value}
                                    </Typography>
                                    <Typography sx={{fontSize: 11, color: "#888", mt: 0.75}}>
                                        {item.helper}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>

            <Box component="div" sx={{mt: 3, mb: 2}}>
                <Title>Seen In Projects</Title>
                <TableContainer component={Paper} variant="outlined" sx={{borderRadius: 2, bgcolor: "background.paper"}}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Project</TableCell>
                                <TableCell align="right">Entries</TableCell>
                                <TableCell>Last Seen</TableCell>
                                <TableCell align="right">Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(channel.projects || []).map((project, idx) => (
                                <TableRow key={project.project_id} hover sx={{bgcolor: idx % 2 === 0 ? "background.paper" : "#fafafa"}}>
                                    <TableCell>
                                        <Typography variant="body2" noWrap title={project.project_name || `Project #${project.project_id}`}>
                                            <Link component={RouterLink} to={`/projects/${project.project_id}`}>
                                                {project.project_name || `Project #${project.project_id}`}
                                            </Link>
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="right">
                                        <Typography variant="body2">{project.entry_count}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">{moment(project.last_seen).format('YYYY-MM-DD HH:mm')}</Typography>
                                    </TableCell>
                                    <TableCell align="right">
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            component={RouterLink}
                                            to={`/projects/${project.project_id}/entry/${project.latest_entry_id}`}
                                        >
                                            Open Latest
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {(!channel.projects || channel.projects.length === 0) && (
                                <TableRow>
                                    <TableCell colSpan={4}>
                                        <Typography variant="body2" sx={{color: "#777"}}>
                                            No project entries found for this channel.
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>

            <Box component="div" sx={{mt: 3, mb: 2}}>
                <Title>Notes</Title>
                <p>Leave a note, something important. Anything. Everybody in your team can see this, not just you.</p>

                <MDEditor
                    value={value}
                    onChange={setValue}
                    preview="edit"
                    commands={[
                        commands.codeEdit, commands.codePreview,
                        commands.bold, commands.code, commands.quote,
                        commands.title1, commands.title2, commands.title3, commands.title4, commands.title5, commands.title6
                    ]}

                />
                <Box component="div" sx={{mt: 2}}>
                <LoadingButton loading={noteLoading} onClick={() => {saveNotes();console.log(value)}} variant="contained" sx={{mr: 2}}>
                   Save
                </LoadingButton>

                    {channel.notes && channel.notes.user && 
                        <small>Notes last updated by {channel.notes.user.display_name} on {moment(channel.notes.notes_last_updated).format('MMMM Do YYYY, h:mm:ssa')}</small>
                    }
                </Box>
            </Box>
            

            {channel.issues && channel.issues.length > 0 && (
                <Box component="div" sx={{mt: 3, mb: 2}}>
                    <Title>Issues related to this channel</Title>
                    <IssueList issues={channel.issues .reverse()} showadvanced={true} />
                </Box>
            )}
            

                <Box component="div" sx={{mt: 3, mb: 2}}>
                    <Title>Videos in this channel</Title>
                    <Grid container spacing={1} sx={{mb: 1}}>
                        <Grid item xs={12} md={7}>
                            <TextField
                                fullWidth
                                size="small"
                                value={videoQuery}
                                onChange={(e) => {
                                    setVideoQuery(e.target.value);
                                }}
                                label="Search videos by title, description or ID"
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="video-status-filter-label">Status</InputLabel>
                                <Select
                                    labelId="video-status-filter-label"
                                    value={statusFilter}
                                    label="Status"
                                    onChange={(e) => {
                                        const nextStatus = e.target.value;
                                        setStatusFilter(nextStatus);
                                        setVideosPage(1);
                                        fetchVideos(1, nextStatus).catch(console.error);
                                    }}
                                >
                                    <MenuItem value="all">All</MenuItem>
                                    <MenuItem value="complete">Complete</MenuItem>
                                    <MenuItem value="incomplete">Incomplete</MenuItem>
                                    <MenuItem value="failed">Failed</MenuItem>
                                    <MenuItem value="pending">Pending</MenuItem>
                                    <MenuItem value="deleted">Deleted</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3} sx={{display: "flex", alignItems: "center"}}>
                            <Typography sx={{color: "#777"}}>
                                Showing {displayedVideos.length} of {videosPageData.items.length} on this page
                                {videosPageData.total ? ` (${videosPageData.total} total)` : ""}
                            </Typography>
                        </Grid>
                    </Grid>

                    <TableContainer component={Box} sx={{border: "1px solid #eee", borderRadius: 1}}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Title</TableCell>
                                    <TableCell>Discovered</TableCell>
                                    <TableCell>Updated</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Signals</TableCell>
                                    <TableCell align="right">Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {videosLoading && (
                                    <TableRow>
                                        <TableCell colSpan={6}>
                                            <Typography sx={{color: "#777"}}>Loading videos...</Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                                {!videosLoading && displayedVideos.map((row, idx) => {
                                    const outLink = openVideoUrl(row);
                                    const statusLabel = getStatusLabel(row.status);
                                    return (
                                        <TableRow key={row.id} hover sx={{ bgcolor: idx % 2 === 0 ? "background.paper" : "#fafafa" }}>
                                            <TableCell sx={{maxWidth: 520}}>
                                                <Typography sx={{fontWeight: 600}}>
                                                    {row.video_title || `Video ${row.video_id}`}
                                                </Typography>
                                                <Typography sx={{fontSize: 12, color: "#777"}} noWrap>
                                                    {row.video_description || "No description"}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                {row.date_received ? moment(row.date_received).format("YYYY-MM-DD HH:mm") : "n/a"}
                                            </TableCell>
                                            <TableCell>
                                                {row.last_updated ? moment(row.last_updated).fromNow() : "n/a"}
                                            </TableCell>
                                            <TableCell>
                                                <Chip
                                                    size="small"
                                                    label={statusLabel}
                                                    color={getStatusColor(statusLabel)}
                                                    variant={statusLabel === "Complete" ? "filled" : "outlined"}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                {row.aff_evidence_exists ? (
                                                    <Chip size="small" color="warning" label="Affiliate signals" />
                                                ) : (
                                                    <Chip size="small" variant="outlined" label="No affiliate signal" />
                                                )}
                                            </TableCell>
                                            <TableCell align="right">
                                                {outLink && (
                                                    <Tooltip title="Open external video">
                                                        <Button
                                                            size="small"
                                                            component="a"
                                                            href={`https://1855proxy.xyz/?${outLink}`}
                                                            target="_blank"
                                                            sx={{mr: 1}}
                                                        >
                                                            <OpenInNewIcon fontSize="small" sx={{mr: 0.5}} />
                                                            View
                                                        </Button>
                                                    </Tooltip>
                                                )}
                                                <Button size="small" variant="outlined" onClick={() => updateDetails(row)}>
                                                    Details
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                                {!videosLoading && displayedVideos.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={6}>
                                            <Typography sx={{color: "#777"}}>No videos match your search.</Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Box sx={{mt: 1.5, display: "flex", justifyContent: "center"}}>
                        <Pagination
                            count={Math.max(1, videosPageData.total_pages || 1)}
                            page={videosPage}
                            onChange={(e, value) => {
                                setVideosPage(value);
                                fetchVideos(value).catch(console.error);
                            }}
                            color="primary"
                        />
                    </Box>
                </Box>

            <Snackbar
                open={snackOpen}
                autoHideDuration={10000}
                onClose={handleClose}
                message="Note has been saved"
                action={action}
            />

            <SimpleBackdrop  open={loading}/>
        </div>
    );
}
